module.exports = __webpack_public_path__ + "img/mirkatech_logo.26fff9b2.jpg";